import { Injectable } from '@angular/core';


@Injectable()
export class ConfigurationService {
    environment: string;
    stripeKey: string;
    baseUrl: string;
    registryUrl: string;
    stripeClientId: string;
    constructor() {


        var url = (window).location.host;

        //window.location.host is subdomain.domain.com
        var parts = url.split('.')
        var sub = parts[0]
        var domain = parts[1]


        switch (domain) {
            case "localhost:4200": {
                this.baseUrl = 'https://hitchd-api-dev.azurewebsites.net';
                this.registryUrl = 'http://{$registry}.localhost:4200';
                this.stripeKey = 'pk_test_rhXTW8eKhbNGyHMeJLbkuEbu';
                this.stripeClientId = 'ca_8dlB8IXZqLjQW15ivgumCW5YxZUePaGg'
                break;
            }

            case "localhost:9820": {
                this.baseUrl = 'http://localhost:5000';
                this.registryUrl = 'http://{$registry}.localhost:9820';
                this.stripeKey = 'pk_test_rhXTW8eKhbNGyHMeJLbkuEbu';
                this.stripeClientId = 'ca_8dlB8IXZqLjQW15ivgumCW5YxZUePaGg'
                break;

            }
            case "kentand": {
                this.baseUrl = 'http://kentand.co';
                this.registryUrl = 'http://{$registry}.kentand.co';
                this.stripeKey = 'pk_test_DZLOsJ6zHfw8ZD4g94g0G0T8';
                this.stripeClientId = 'ca_ASgpSjbfqxpkmZVf6zQJlroq2AFf9G5p';
                break;

            }

            case "hitchd": {
                this.baseUrl = 'https://www.hitchd.com';
                this.registryUrl = 'https://{$registry}.hitchd.com';
                this.stripeKey = 'pk_live_y4sqBdV7zz8DygAQkm9HsGfw';
                this.stripeClientId = 'ca_ASgp1FSuN5Gcvg48nKYUOXVfQfgcSQ8n';
                break;
            }
        }

        // //sub is 'subdomain', 'domain', type is 'com'
        // var newUrl = 'http://' + domain + '.' + type + '/your/other/path/' + subDomain
        // window.open(newUrl);


    }
}



// WEBPACK FOOTER //
// ./src/app/shared/configuration.service.ts